import { faArrowUpFromBracket, faBars, faXmark } from '@fortawesome/pro-light-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Suspense } from 'react';

import ClickOutside from 'Component/ClickOutside';
import Link from 'Component/Link';
import Menu from 'Component/Menu';
import OfflineNotice from 'Component/OfflineNotice';
import SearchField from 'Component/SearchField';
import SearchIcon from 'Component/SearchIcon';
import UserIcon from 'Component/UserIcon';
import FraseHead from 'Component/YBFraseHead';
import {
    FAQ, GANSOCIETY, MY_GIFT_CARDS, NOTIFICATIONS, RECOMIENDAAPP, RMA, SETTINGS
} from 'Route/MyAccount/MyAccount.config';
import {
    CartOverlay,
    Header as SourceHeader,
    MyAccountOverlay
} from 'SourceComponent/Header/Header.component';
import {
    ACCOUNT_INFORMATION,
    ADDRESS_BOOK,
    MY_ORDERS,
    MY_WISHLIST,
    NEWSLETTER_SUBSCRIPTION
} from 'Type/Account.type';
import { isSignedIn } from 'Util/Auth';
import { isCrawler, isSSR } from 'Util/Browser';
import { decodeString } from 'Util/Common';
import isMobile, { isApp } from 'Util/Mobile/isMobile';
import getStore from 'Util/Store';
import { isHomePageUrl } from 'Util/Url';

import {
    CART_OVERLAY,
    CATEGORY,
    CUSTOMER_WISHLIST,
    FILTER,
    PDP,
    POPUP,
    SEARCH
} from './Header.config';

import './Header.override.style';

export {
    CartOverlay,
    MyAccountOverlay
};

/** @namespace Elganso/Component/Header/Component */
export class HeaderComponent extends SourceHeader {
    onHoverMenu = this.onHoverMenu.bind(this);

    onClickShowMenuDesktop = this.onClickShowMenuDesktop.bind(this);

    onClickCloseMenuDesktop = this.onClickCloseMenuDesktop.bind(this);

    onHoverMenu() {
        // const { showMenu } = this.props;
        // showMenu();

        // const { showMenuDesktop } = this.props;
        // showMenuDesktop();
    }

    onClickShowMenuDesktop() {
        const { showMenuDesktop, showingMenuDesktop } = this.props;

        if (!showingMenuDesktop) {
            showMenuDesktop();
        }
    }

    onClickCloseMenuDesktop() {
        const { closeMenuDesktop } = this.props;
        closeMenuDesktop();
    }

    onClickShowMenuShare() {
        const { showMenuShare, showingMenuShare } = this.props;

        if (!showingMenuShare) {
            showMenuShare();
        }
    }

    onClickCloseMenuShare() {
        const { closeMenuShare } = this.props;
        closeMenuShare();
    }

    stateMap = {
        ...this.stateMap,
        [ACCOUNT_INFORMATION]: {
            title: false,
            back: true
        },
        [ADDRESS_BOOK]: {
            title: false,
            back: true
        },
        [FAQ]: {
            title: false,
            back: true
        },
        [GANSOCIETY]: {
            title: false,
            back: true
        },
        [MY_ORDERS]: {
            title: false,
            back: true
        },
        'my-stripe-payments': {
            title: false,
            back: true
        },
        SEARCH_TAB: {
            title: false,
            back: true
        },
        LANGUAGES: {
            title: false,
            back: true
        },
        [NEWSLETTER_SUBSCRIPTION]: {
            title: false,
            back: true
        },
        [NOTIFICATIONS]: {
            title: false,
            back: true
        },
        [SETTINGS]: {
            title: false,
            back: true
        },
        [PDP]: {
            back: true,
            title: false
        },
        [CATEGORY]: {
            back: true,
            title: false
        },
        [RMA]: {
            back: true,
            title: false
        },
        [FILTER]: {
            close: false,
            title: true
        },
        [POPUP]: {
            title: true,
            close: false
        },
        [MY_WISHLIST]: {
            back: true
        },
        [MY_GIFT_CARDS]: {
            back: true
        },
        'my-account': {
            back: true
        },
        [RECOMIENDAAPP]: {
            back: true
        }
    };

    renderMap = {
        cancel: this.renderCancelButton.bind(this),
        back: this.renderBackButton.bind(this),
        close: this.renderCloseButton.bind(this),
        title: this.renderTitle.bind(this),
        logo: this.renderLogo.bind(this),
        search: this.renderSearchField.bind(this),
        renderDesktopIcons: this.renderDesktopIcons.bind(this),
        share: this.renderShareWishListButton.bind(this),
        ok: this.renderOkButton.bind(this)
    };

    renderSearchField(isVisible = false) {
        const {
            searchCriteria,
            onSearchOutsideClick,
            onSearchBarFocus,
            onSearchBarChange,
            onClearSearchButtonClick,
            navigationState: { name },
            isCheckout,
            hideActiveOverlay,
            device: { isMobile }
        } = this.props;

        if (isCheckout || isMobile) {
            return null;
        }

        // eslint-disable-next-line no-constant-condition
        if (true) {
            return null;
        }

        return (
            <SearchField
              key="search"
              searchCriteria={ searchCriteria }
              onSearchOutsideClick={ onSearchOutsideClick }
              onSearchBarFocus={ onSearchBarFocus }
              onSearchBarChange={ onSearchBarChange }
              onClearSearchButtonClick={ onClearSearchButtonClick }
              isVisible={ isVisible }
              isActive={ name === SEARCH }
              hideActiveOverlay={ hideActiveOverlay }
            />
        );
    }

    renderAccountButton() {
        const {
            onMyAccountButtonClick,
            onSignInAccountButtonClick,
            device
        } = this.props;

        if (device.isMobile && !isApp()) {
            return (
                <button
                  block="Header"
                  elem="MyAccountWrapper"
                  tabIndex="0"
                  onClick={ onSignInAccountButtonClick }
                  aria-label="Open my account"
                  id="myAccount"
                >
                    <UserIcon />
                </button>
            );
        }

        return (
            <button
              block="Header"
              elem="MyAccountWrapper"
              tabIndex="0"
              onClick={ onMyAccountButtonClick }
              aria-label="Open my account"
              id="myAccount"
            >
                <UserIcon />
            </button>
        );
    }

    renderAccount(isVisible = false) {
        const {
            onMyAccountOutsideClick,
            isCheckout
        } = this.props;

        if (isApp() && !isCheckout) {
            return null;
        }

        if (isMobile && isCheckout) {
            return null;
        }

        if (isCheckout && isSignedIn()) {
            return null;
        }

        return (
            <div key="account" block="Header" elem="MyAccountContainer">
                { this.renderWelcomeMessage() }
                <ClickOutside
                  onClick={ onMyAccountOutsideClick }
                >
                    <div
                      aria-label="My account"
                      block="Header"
                      elem="MyAccount"
                    >
                        { this.renderAccountButton(isVisible) }
                        { this.renderAccountOverlay() }
                    </div>
                </ClickOutside>
            </div>
        );
    }

    renderShareFooter() {
        const {
            isCheckout,
            onShareFooterOutsideClick,
            onShareFooterClick,
            showShareFooter
        } = this.props;

        if (isCheckout) {
            return null;
        }

        return (
            <div key="share-footer" block="Header" elem="ShareFooterContainer">
                <ClickOutside
                  onClick={ onShareFooterOutsideClick }
                >
                    <div
                      aria-label="Share footer"
                      block="Header"
                      elem="ShareFooter"
                    >
                        <FontAwesomeIcon onClick={ onShareFooterClick } className="fa-sharp" icon={ faArrowUpFromBracket } />
                        { (showShareFooter)
                            ? this.renderSharedFooter()
                            : null }
                    </div>
                </ClickOutside>
            </div>
        );
    }

    renderSharedFooter() {
        const {
            onShareFooterOutsideClick,
            onShareFooterLink,
            location: {
                pathname
            }
        } = this.props;

        return (
            <div
              block="ShareFooter"
              elem="menu"
            >
                <div
                  block="ShareFooter"
                  elem="list"
                >
                    <Link
                      to={ pathname }
                      block="ShareFooter"
                      elem="link"
                      onClick={ onShareFooterLink }
                    >
                        <div className="separador">{ __('Compartir contenido') }</div>
                    </Link>
                    <Link
                      to="/descarga-app"
                      block="ShareFooter"
                      elem="link"
                      onClick={ onShareFooterOutsideClick }
                    >
                        <div className="separador">{ __('Compartir descarga App') }</div>
                    </Link>
                    <Link
                      to="/share-footer"
                      block="ShareFooter"
                      elem="link"
                      onClick={ onShareFooterOutsideClick }
                    >
                        <div className="separador">{ __('Información El Ganso') }</div>
                    </Link>
                    <Link
                      to="/wishlist"
                      block="ShareFooter"
                      elem="link"
                      onClick={ onShareFooterOutsideClick }
                    >
                        <div className="separador">{ __('Mi lista de deseos') }</div>
                    </Link>
                    <Link
                      to="/storespage"
                      block="ShareFooter"
                      elem="link"
                      onClick={ onShareFooterOutsideClick }
                    >
                        <div>{ __('Tiendas') }</div>
                    </Link>
                </div>
            </div>
        );
    }

    renderDesktopIcons() {
        const {
            device: { isMobile }
        } = this.props;

        if (isApp()) {
            return (
                <div
                  block="Header"
                  elem="IconsWrapper"
                  key="IconsWrapper"
                >
                    { this.renderMinicart() }
                </div>
            );
        }

        if (isMobile) {
            return (
                <div
                  block="Header"
                  elem="IconsWrapper"
                  key="IconsWrapper"
                >
                    { this.renderSearchIcon() }
                    { this.renderAccount() }
                    { this.renderMinicart() }
                </div>
            );
        }

        return (
            <div
              block="Header"
              elem="IconsWrapper"
              key="IconsWrapper"
            >
                { this.renderSearchIconDesktop() }
                { this.renderAccount() }
                { this.renderMinicart() }
            </div>
        );
    }

    renderMenuGanso() {
        const { showingMenuDesktop, location } = this.props;

        return (
            <>
                <span
                  block="Header"
                  elem="MenuGansoWrapper"
                  key="MenuGansoWrapper"
                  onClick={ this.onClickShowMenuDesktop }
                  onKeyDown={ this.onClickShowMenuDesktop }
                >
                    { (showingMenuDesktop) ? (
                        <FontAwesomeIcon onClick={ this.onClickCloseMenuDesktop } className="closeMenu faXmark" icon={ faXmark } />
                    ) : (
                        <FontAwesomeIcon className="fa-sharp" icon={ faBars } />
                    ) }
                </span>
                { (showingMenuDesktop) ? (
                    <div
                      block="Header"
                      elem="MenuIzquierdaHeader"
                      key="MenuIzquierdaHeader"
                      className={ !isApp() ? 'notApp' : 'isApp' }
                    >
                        <FontAwesomeIcon onClick={ this.onClickCloseMenuDesktop } className="closeMenu faXmark" icon={ faXmark } />
                        <Menu activeOption={ location?.state?.category ? location?.state?.category : 0 } />
                    </div>
                ) : (
                    ''
                ) }
            </>
        );
    }

    renderSearchIconDesktop(isActive = true) {
        const {
            isCheckout
        } = this.props;

        if (isCheckout) {
            return null;
        }

        const { onSearchButtonClick } = this.props;

        return (
            <div className="Header-SearchContainer">
                <div aria-label="My account" className="Header-Search">
                    <button
                      key="searchButtonHeader"
                      block="Header"
                      elem="ButtonSearch"
                      aria-label="search"
                      mods={ { type: 'search' } }
                      onClick={ onSearchButtonClick }
                    >
                        <SearchIcon key="searchIcon" isActive={ isActive } />
                    </button>
                </div>
            </div>
        );
    }

    renderSearchIcon(isActive = true) {
        const {
            isCheckout,
            device: { isMobile }
        } = this.props;

        if (isCheckout || !isMobile) {
            return null;
        }

        const { onSearchButtonClick } = this.props;

        return (
            <button
              key="searchButtonHeader"
              block="Header"
              elem="ButtonSearch"
              aria-label="search"
              mods={ { type: 'search' } }
              onClick={ onSearchButtonClick }
            >
                <SearchIcon key="searchIcon" isActive={ isActive } />
            </button>
        );
    }

    renderLogo(isVisible = false) {
        const { isLoading, device: { isMobile } } = this.props;
        if (isMobile) {
            // eslint-disable-next-line no-param-reassign
            isVisible = true;
        }

        if (isLoading) {
            return null;
        }

        return (
            <Link
              to="/"
              aria-label="Go to homepage by clicking on ScandiPWA logo"
              aria-hidden={ !isVisible }
              tabIndex={ isVisible ? 0 : -1 }
              block="Header"
              elem="LogoWrapper"
              mods={ { isVisible } }
              key="logo"
            >
                { this.renderLogoImage() }
            </Link>
        );
    }

    renderMinicartOverlayFallback() {
        return null;
    }

    renderMinicartOverlay() {
        return (
            <Suspense fallback={ this.renderMinicartOverlayFallback() }>
                <CartOverlay />
            </Suspense>
        );
    }

    renderMinicart(isVisible = false) {
        const {
            onMinicartOutsideClick,
            isCheckout
        } = this.props;

        if (isCheckout) {
            return null;
        }

        return (
            <ClickOutside
              onClick={ onMinicartOutsideClick }
              key="minicart"
              isMiniCart
            >
                <div
                  block="Header"
                  elem="Button"
                  mods={ { isVisible, type: 'minicart' } }
                >
                    { this.renderMinicartButton() }
                    { this.renderMinicartOverlay() }
                </div>
            </ClickOutside>
        );
    }

    renderTitle(isVisible = false) {
        const { navigationState: { name }, logo_alt } = this.props;
        let { navigationState: { title } } = this.props;

        if (name === 'category' || name === 'product' || name === 'pdp') {
            return null;
        }
        if (name === 'default') {
            title = logo_alt;
        }

        return (
            <h1
              key="title"
              block="Header"
              elem="Title"
              mods={ { isVisible } }
            >
                { title ? (<span>{ decodeString(title.replace(/\+/g, ' ')) }</span>) : (<span>{ title }</span>) }
            </h1>
        );
    }

    render() {
        const { fraseHeadConfig = {} } = getStore().getState().ConfigReducer;
        const { stateMap } = this;
        const {
            navigationState: { name, isHiddenOnMobile = false },
            isCheckout
        } = this.props;

        // hide edit button on desktop
        stateMap[CUSTOMER_WISHLIST].edit = false;
        stateMap[CUSTOMER_WISHLIST].share = false;
        stateMap[CART_OVERLAY].edit = false;

        if (isApp()) {
            const navigationStateRenderSearch = this.renderNavigationState().filter((item) => (item ? item.key === 'search' : false));
            const navigationStateRenderResto = this.renderNavigationState().filter((item) => (item ? item.key !== 'search' : false));

            return (
                <section
                  block="Header"
                  elem="Wrapper"
                  mods={ { isPrerendered: isSSR() || isCrawler() } }
                  className={ isApp() ? 'isApp' : '' }
                >
                    <header
                      block="Header"
                      mods={ { name, isHiddenOnMobile, isCheckout } }
                      mix={ { block: 'FixedElement', elem: 'Top' } }
                      ref={ this.logoRef }
                    >
                        <nav block="Header" elem="Nav">
                            { navigationStateRenderResto }
                        </nav>
                    </header>
                    <div block="Header" elem="subHeader">
                        { navigationStateRenderSearch }
                    </div>
                    <OfflineNotice />
                </section>
            );
        }

        return (
            <section
              block="Header"
              elem="Wrapper"
              mods={ { isPrerendered: isSSR() || isCrawler() } }
            >
                <header
                  block="Header"
                  mods={ { name, isHiddenOnMobile, isCheckout } }
                  mix={ { block: 'FixedElement', elem: 'Top' } }
                  ref={ this.logoRef }
                  className={ (isHomePageUrl(window.location.pathname) ? ' homePage' : '') }
                >
                    <FraseHead fraseHeadConfig={ fraseHeadConfig } />
                    <nav block="Header" elem="Nav">
                        { this.renderMenuGanso() }
                        { this.renderNavigationState() }
                    </nav>
                </header>
                <OfflineNotice />
            </section>
        );
    }
}

export default HeaderComponent;
